
import { useCallback } from "react";
import environment from "../../utils/Environment";
import { getGemsSubscriptionContract } from "../../utils/contractHelpers";
import useWeb3 from "../useWeb3";

const StakeGems = () => {
  const web3 = useWeb3();
  const tokenAddress = environment.GemsSubscription;
  const contract = getGemsSubscriptionContract(tokenAddress, web3);
  const stakeGems = useCallback(
    async (postApiRes, account, token, increasedAmount) => {
      // console.log(postApiRes, account, token, increasedAmount, 'postApiRes, account, token, increasedAmount');
     
      try {
     
        let details;
        if (token?.NAME === 'ETH') {
          console.log(postApiRes, account, token, increasedAmount, 'postApiRes, account, token, increasedAmount');
          
          details = await contract.methods
            .subscribeWithETH(
              postApiRes?.deadline,
              postApiRes?.v,
              postApiRes?.r,
              postApiRes?.s
            )
            .send({
              from: account,
              value: increasedAmount
              // gas,
            });

        } else {
          details = await contract.methods
            .subscribeWithToken(
              token?.tokenAddress,
              postApiRes?.price,
              postApiRes?.deadline,
              postApiRes?.normalizationFactor,
              postApiRes?.v,
              postApiRes?.r,
              postApiRes?.s
            )
            .send({
              from: account,
              // gas,
            });

        }
        const transactionHash = details.transactionHash;
        console.log("Transaction Hash:", transactionHash);

        const receipt = await web3.eth.getTransactionReceipt(transactionHash);
        console.log("Transaction receipt:", receipt);

        const blockNumber = receipt.blockNumber;
        console.log("Transaction block number:", blockNumber);

        const block = await web3.eth.getBlock(blockNumber);
        console.log("Transaction block :", block);

        const timestamp = block.timestamp;

        console.log("Transaction Timestamp:", timestamp);

        return { details, transactionHash, timestamp };
      } catch (error) {
        console.log("I'm error === >", error);
        
        throw error;
      }
    },
    [contract, web3]
  );
  return { stakeGems: stakeGems };
};
export default StakeGems;
